import { IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { Subscription } from 'rxjs';
import { KeyValuePairArray } from '../../../models/KeyValuePair';
import { LoginResponse } from '../../../models/ss-api/responses/login.response';
import { GlobalService } from '../../../services/global.service';
import { ssApiService } from '../../../services/ss-api.service';
import { HttpError } from '../../../models/errors/HttpError';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import 'rxjs';
import { LoginRequest } from '../../../models/ss-api/requests/login.request';
import { ErrorEventArgs } from '../../../models/event-args/global-error.event.args';
import { Title } from '@angular/platform-browser';


@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html'
})
export class LoginFormComponent implements OnInit {

    // events
    @Output('onBusyChanged') onBusyChanged = new EventEmitter<Boolean>();
    @Output('onAuthenticationFailed') onAuthenticationFailed = new EventEmitter<LoginResponse>();
    @Output('onTwoFactorRequired') onTwoFactorRequired = new EventEmitter<KeyValuePairArray<string, string>>();
    @Output('onAuthenticated') onAuthenticated = new EventEmitter<IBaseResponse<any>>();
    @Output('onError') onError = new EventEmitter<ErrorEventArgs>();


    // form
    signinForm: FormGroup

    // private
    showTimeout: boolean = true;


    constructor(private api: ssApiService, private gb: GlobalService, private titleService: Title) {
    }


    ngOnInit() {
        this.gb.SetPageTitle('SSDB Login');
        // this.titleService.setTitle('SSDB Login')
        let email = localStorage.getItem('crm_Email');
        if (email == null) { email = '' };

        this.signinForm = new FormGroup({
            'email': new FormControl(email, [Validators.required, Validators.email]),
            'password': new FormControl('', [Validators.required, Validators.minLength(5)])
        })
    }


    checkEmailValid(): boolean {

        if (!this.signinForm.get('email').touched)
            return true;

        return this.signinForm.get('email').valid;
    }

    checkPasswordValid(): boolean {

        if (!this.signinForm.get('password').touched)
            return true;

        return this.signinForm.get('password').valid;
    }

    SaveEmail() {
        localStorage.setItem('crm_Email', this.signinForm.controls['email'].value);
    }

    private ResetSigninFormSubmitRequest(request: Subscription) {
        request.unsubscribe();
        this.showTimeout = false;
        this.onBusyChanged.emit(false);
    }

    async onSigninFormSubmit() {


        this.onBusyChanged.emit(true);

        let data = new LoginRequest();
        data.Username = this.signinForm.get('email').value;
        data.Password = this.signinForm.get('password').value;
        data.Checksum = 'SFHSDKFHSDFHsdkfsdf2s4df85s4df524sd5f4sSDNFNDFSDKFJsdkfowefhSDFSDfFaustoksdCaltabiano!!!sdfSDHFkds5245';

        data.DeviceID = localStorage.getItem("DeviceID");
        if (data.DeviceID == null || data.DeviceID == undefined)
            data.DeviceID = "";

        this.signinForm.setValue['password'] = '';

        let request = this.api.Login(data)
            .subscribe(async response => {

                this.ResetSigninFormSubmitRequest(request);


                if (!response.Result) {
                    // error
                    this.onAuthenticationFailed.emit(response.Data);
                    return;
                }

                let data = response.Data;
                if (!data.Authenticated && !data.TwoFactorRequired) {
                    // not authenticated
                    this.onAuthenticationFailed.emit(data);
                    return;
                }

                // set data in globals
                console.log(data);
                this.gb.SetGlobalsFromLoginResponse(response.Data);
                this.gb.ReadFromStorage();



                if (data.TwoFactorRequired) {
                    // twofactor required
                    this.onTwoFactorRequired.emit(data.TwoFactorOptions);
                    return;
                }
                else
                {
                    localStorage.setItem('is_authenticated', "1");

                    // setup user roles
                    this.gb.LoadSignature();
                    this.gb.SetupUserRole();
                    this.gb.GetGravatar();
                }

                this.onAuthenticated.emit(response);
            },


                (error: HttpError) => {
                    this.ResetSigninFormSubmitRequest(request);

                    this.onError.emit(new ErrorEventArgs('0', error.OriginalError, error.FriendlyMessage, error.FriendlyTitle));
                }
            );


        // set timeout
        this.showTimeout = true;

        setTimeout(() => {

            this.ResetSigninFormSubmitRequest(request);

            if (this.showTimeout)
                this.onError.emit(new ErrorEventArgs('0', 'timeout', 'Error connecting to server. Please try again later.', 'Timeout Error'));

        }, this.gb.HttpTimeout);

    }

   



}
